let navbar = document.querySelector('.all-navbar');

window.onscroll = () => {

    if (window.scrollY > 150) {
        navbar.classList.add("fixed-nav");
        mainNav.classList.remove('active-nav')
    }
    else {
       navbar.classList.remove("fixed-nav");
    }
}

let mainNav = document.querySelector('.main-nav');
let menuBtn = document.querySelector('.mbl-menu-btn')
let closeNav = document.querySelector('.close-nav')

menuBtn.onclick = ()=>{
     mainNav.classList.toggle('active-nav')
}
closeNav.onclick = ()=>{
    mainNav.classList.remove('active-nav')
}

let bookFrom = document.querySelector('#consultation-form');
let closeFrom = document.querySelector('.close-form')
const buttons = document.querySelectorAll(".booking-form-btn");

for (let i = 0; i < buttons.length; i++) {
   buttons[i].onclick = function() {
     bookFrom.style.display = "block";
   };
}
closeFrom.onclick = ()=>{
    bookFrom.style.display = "none";
}

const showVideoButton = document.getElementById("open-video-yt");
const videoPopup = document.getElementById("yt-video-pd");
const closeVideo = document.getElementById("close-yt-video");

showVideoButton.addEventListener("click", function() {
  videoPopup.style.display = "block";
});

closeVideo.addEventListener("click", function() {
  videoPopup.style.display = "none";
});

  var swiper = new Swiper(".mySwiper1", {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
        450: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        350: {
          slidesPerView: 1,
          spaceBetween: 0
        },
      },
      });

       function openModal(img) {
            var modal = document.getElementById("modal");
            var modalImg = document.getElementById("img01");
            modal.style.display = "block";
            modalImg.src = img.src.replace("thumbnail", "fullsize");
        }

        function closeModal() {
            var modal = document.getElementById("modal");
               modal.style.display = "none";
        }
  

